import React from "react";
import WhatService from '../components/what-service';
import HowToGuidesImage from '../components/how-to-guides-image';
import PopularProjectsNearYou from "../components/popular-projects-near-you";
import ProjectTypesList from "../components/project-types-list";
import LayoutDumpster from "../components/layout-dumpster";
import ZipFinderState from "../components/zip-finder-state";
import HowNearMeDumpster from "../components/how-nearme-dumpster";
import AreYouAProfessionalDumpster from "../components/are-you-a-professional-dumpster";
import CitiesListHome from "../components/cities-list-home";
import StatesListHome from "../components/state-list-home";

const PROPAGEDUMPSTER = ({ pageContext }) => 
{    
    const states = pageContext.states.length > 0 ? pageContext.states : [];
    const codes = pageContext.codes.length > 0 ? pageContext.codes : [];
    const code = pageContext.code;    
    const env = pageContext.env;
    const cities = pageContext.cities.length > 0 ? pageContext.cities : [];
    const project_types = pageContext.project_types
    const popular_projects = pageContext.popular_projects

    const HUB = pageContext.HUB;

    if(HUB.length > 0) cities.push(HUB[0])

    const seo_desc = pageContext.seo_desc;
    const seo = 
    {
        url: pageContext.url,
        env: env,
        code: code,
        page: 'home',
        seo_desc: seo_desc
    }

    const pickTitle = () => {
        let title = "Find {code}";
        codes.map(element => {
            if (code === element.code) {
                title = title.replace('{code}', element.name);
            }
            return true
        })
        return title
    }

    const pickText = () => {
        let text = "We’ll introduce you to top {code} providers in your area";
        codes.map(element => {
            if (code === element.code) {
                text = text.replace('{code}', element.name.toLowerCase());
            }

            return true;
        })

        return text;
    }

    return (

        <LayoutDumpster seo={seo} env={env} code={code}>
            
            <ZipFinderState
                id= 'home-zip-code'
                code = {code}
                button = "Find Pros"
                bottomtext = "America's #1 Source for Dumpsters and Junk Removal"
                codes = {codes}
                env = {env}
                title = {pickTitle()}
                text = {pickText()}
                finderopenmodal = {false}
                redirectToKpp={true}
            />

            <WhatService 
                env={env}
            />

            <PopularProjectsNearYou popular_projects={popular_projects} env={env}/>

            <HowNearMeDumpster
                page='home'
            />

            <CitiesListHome
                cities = {cities}
                code = {code}
                codes = {codes}
                env = {env}
            />
            
            { (code === 'dumpster' || code === 'junk-removal') &&
            <HowToGuidesImage code={code}/>
            }

            <AreYouAProfessionalDumpster />

            <StatesListHome
                states = {states}                    
                code = {code}     
                codes = {codes}
                env = {env}
                page = 'pro'
                /> 
            
            <ProjectTypesList 
                title='Popular Categories'
                project_types={project_types}
                env={env}
            />


        </LayoutDumpster>
   )
};

export default PROPAGEDUMPSTER;